import { BuildingOffice2Icon, UserIcon } from '@heroicons/react/24/outline';
import type {
    OrthodontistDetailInfo,
    OrthodontistPracticeSummary
} from '../../../../services/orthodontistAccounts';
import type { OrthodontistCreateFieldGridProps } from '../create/OrthodontistCreateFieldGrid';
import { OrthodontistGroupCard } from './OrthodontistGroupCard';
import { OrthodontistLinkedPracticesCard } from './OrthodontistLinkedPracticesCard';
import {
    ORTHODONTIST_DOCTOR_FIELDS,
    ORTHODONTIST_ORGANIZATION_FIELDS
} from './orthodontistInfoFields';

interface OrthodontistInfoSectionProps extends Omit<OrthodontistCreateFieldGridProps, 'fields'> {
    orthodontist: OrthodontistDetailInfo;
    practices: OrthodontistPracticeSummary[];
}

export function OrthodontistInfoSection({
    orthodontist,
    practices,
    ...gridProps
}: OrthodontistInfoSectionProps) {
    return (
        <div className="flex flex-col gap-3.5 shrink-0">
            <OrthodontistGroupCard
                icon={BuildingOffice2Icon}
                label="Organization"
                fields={ORTHODONTIST_ORGANIZATION_FIELDS}
                {...gridProps}
            />
            <OrthodontistGroupCard
                icon={UserIcon}
                label="Doctor"
                fields={ORTHODONTIST_DOCTOR_FIELDS}
                {...gridProps}
            />
            <OrthodontistLinkedPracticesCard
                orthodontistId={orthodontist.id}
                orthodontistName={orthodontist.name}
                practices={practices}
            />
        </div>
    );
}
